import { Component } from "@/decorators";
import NbmModel from "@/models/produto/nbmModel";
import nbmService from "@/services/produto/nbmService";

import EditComponentBase from "../editComponentBase";

@Component
export default class NbmEditComponent extends EditComponentBase<NbmModel> {
    private async beforeMount() {
        await this.setPropsCached(nbmService, "nbms", new NbmModel());
    }
}
